import React from 'react';

export default function DesktopSetting({ renderData }) {
  return (
    <div className="desktop-setting-wrapper">
      {renderData.map((renderItem, index) => {
        if (renderItem.enabled) {
          return (
            <div className="setting-wrapper" key={index}>
              {renderItem.component}
            </div>
          );
        }
      })}
    </div>
  );
}
